import { shape, string, number } from 'prop-types';

/**
 * Determines the type of progress bar based on its color and percent value
 * @param {Object} progressBar - The progress bar object
 * @param {string} progressBar.color - The color of the progress bar ('neutral', 'success', 'warning')
 * @param {number} progressBar.percent - The percentage value of the progress bar
 * @returns {string} The type of progress bar ('zero', 'progress', 'complete', 'error')
 */

const getTypeFromProgressBar = (progressBar) => {
  if (!progressBar) {
    return 'zero';
  }

  const { color, percent } = progressBar;

  const types = {
    neutral: percent > 0 ? 'progress' : 'zero',
    success: 'complete',
    warning: 'error',
  };

  return types[color] || 'zero';
};

getTypeFromProgressBar.propTypes = {
  progressBar: shape({
    color: string,
    percent: number,
  }),
};

export default getTypeFromProgressBar;
